import { useMemo } from 'react';

import { EBindingMode } from '@modules/items';
import { TTemplateUsage, TVersion } from '../../types';
import { BindingModeBadge, SidebarTree, buildVersionGroupedSections, TSidebarTreeSection } from '@shared/components';
import { TERMINOLOGY } from '@shared/i18n';

type TProps = {
  templateUsage?: TTemplateUsage;
  versions: TVersion[];
};

const TemplateUsageTree = ({ templateUsage, versions }: TProps) => {
  const sections = useMemo<TSidebarTreeSection[]>(() => {
    if (!templateUsage) return [];
    return buildVersionGroupedSections(
      versions,
      templateUsage,
      (doc) => `/document/${doc._id}`,
      (doc) => (
        <>
          {doc.name} <BindingModeBadge isBound={doc.mode === EBindingMode.BOUND} />
        </>
      )
    );
  }, [templateUsage, versions]);

  const templateTreeProps = useMemo(
    () => (sections.length > 0 ? { defaultOpenItems: [sections[0].id] } : undefined),
    [sections]
  );

  return (
    <SidebarTree
      ariaLabel={`Documents using this ${TERMINOLOGY.template.lower}`}
      sections={sections}
      treeProps={templateTreeProps}
    />
  );
};

export default TemplateUsageTree;
